var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDataIcon = function SvgDataIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#data-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60 89.62c20.553 0 37.215-16.662 37.215-37.215S80.553 15.19 60 15.19 22.785 31.852 22.785 52.405 39.447 89.62 60 89.62"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E6E6E6",
    d: "M60 89.24c20.344 0 36.835-16.491 36.835-36.835S80.344 15.57 60 15.57 23.165 32.06 23.165 52.405 39.656 89.24 60 89.24Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#data-icon_svg__b)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M49.367 44.43c0 2.203 4.761 3.988 10.633 3.988s10.633-1.785 10.633-3.988m-21.266 0c0-2.202 4.761-3.987 10.633-3.987s10.633 1.785 10.633 3.987m-21.266 0v7.975m21.266-7.975v7.31m-21.266.665c0 2.202 4.761 3.987 10.633 3.987m-10.633-3.987v7.975c0 2.202 4.761 3.987 10.633 3.987M70.9 63.304l2.392 2.392m-9.304-5.316a3.987 3.987 0 1 0 7.975 0 3.987 3.987 0 0 0-7.975 0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "data-icon_svg__b",
    x1: 73.291,
    x2: 44.962,
    y1: 65.696,
    y2: 47.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15A22"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "data-icon_svg__a",
    width: 104.671,
    height: 104.671,
    x: 7.665,
    y: 10.07,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_158_124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_158_124",
    result: "shape"
  })))));
};
export default SvgDataIcon;